import { createConfigLoader } from "@/config";
import { LocaleToLabelMap, SupportedLocale } from "@/enums/locale.enum";

// Interface for language tab configuration
export interface ILanguageTab {
  key: SupportedLocale;
  label: string;
}

// Interface for locale configuration
export interface ILocaleConfig {
  supportedLocales: SupportedLocale[];
  defaultLocale: SupportedLocale;
  languageTabs: ILanguageTab[];
}

// Default locale configuration
const defaultLocaleConfig: ILocaleConfig = {
  supportedLocales: [
    SupportedLocale.EN,
    SupportedLocale.RU,
    SupportedLocale.EL,
    SupportedLocale.FR,
    SupportedLocale.AR,
    SupportedLocale.ES,
  ],
  defaultLocale: SupportedLocale.EN,
  languageTabs: [
    {
      key: SupportedLocale.EN,
      label: LocaleToLabelMap.get(SupportedLocale.EN)!,
    },
    {
      key: SupportedLocale.RU,
      label: LocaleToLabelMap.get(SupportedLocale.RU)!,
    },
    {
      key: SupportedLocale.EL,
      label: LocaleToLabelMap.get(SupportedLocale.EL)!,
    },
    {
      key: SupportedLocale.FR,
      label: LocaleToLabelMap.get(SupportedLocale.FR)!,
    },
    {
      key: SupportedLocale.AR,
      label: LocaleToLabelMap.get(SupportedLocale.AR)!,
    },
    {
      key: SupportedLocale.ES,
      label: LocaleToLabelMap.get(SupportedLocale.ES)!,
    },
  ],
};

// Load configuration with country-specific overrides
const localeConfig = createConfigLoader(defaultLocaleConfig, "locale");

// Export functions for backward compatibility
export const getSupportedLocalesArray = (): Array<SupportedLocale> => {
  return localeConfig.supportedLocales;
};

export const getLanguageTabs = (): ILanguageTab[] => {
  return localeConfig.languageTabs;
};

export const getFilteredLanguageTabs = (
  allowedLanguages: SupportedLocale[],
): ILanguageTab[] => {
  return localeConfig.languageTabs.filter((tab) =>
    allowedLanguages.includes(tab.key),
  );
};

export const isSupportedLocale = (
  locale: string,
): locale is SupportedLocale => {
  return localeConfig.supportedLocales.includes(locale as SupportedLocale);
};

export const getDefaultLocale = (): SupportedLocale => {
  return localeConfig.defaultLocale;
};
